// Apolo IDE — usePlanList hook (sprint plan-tab-v1, E2).
//
// Carrega + cria + deleta planos. Sincroniza com useAgentStore.plan.plans
// pra outros componentes consumirem sem chamar API.

import { useCallback, useEffect, useState } from 'react';
import { useAgentStore } from '../store/useAgentStore.js';
import { listPlans, createPlan as apiCreatePlan, deletePlan as apiDeletePlan, patchPlan as apiPatchPlan } from '../lib/plan/api.js';

export function usePlanList() {
  const plans = useAgentStore((s) => s.plan.plans);
  const setPlans = useAgentStore((s) => s.setPlans);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    const res = await listPlans();
    setLoading(false);
    if (!res.ok) { setError(res.error || 'Falha ao carregar planos'); return; }
    setPlans(res.data?.plans ?? []);
  }, [setPlans]);

  useEffect(() => { refresh(); }, [refresh]);

  const create = useCallback(async (fields) => {
    const res = await apiCreatePlan(fields);
    if (!res.ok) return { ok: false, error: res.error };
    const plan = res.data?.plan;
    if (plan) setPlans([plan, ...plans]);
    return { ok: true, plan };
  }, [plans, setPlans]);

  const remove = useCallback(async (id) => {
    const res = await apiDeletePlan(id);
    if (!res.ok) return { ok: false, error: res.error };
    setPlans(plans.filter((p) => p.id !== id));
    return { ok: true };
  }, [plans, setPlans]);

  const patch = useCallback(async (id, fields) => {
    const res = await apiPatchPlan(id, fields);
    if (!res.ok) return { ok: false, error: res.error };
    const updated = res.data?.plan;
    if (updated) setPlans(plans.map((p) => (p.id === id ? updated : p)));
    return { ok: true, plan: updated };
  }, [plans, setPlans]);

  return { plans, loading, error, refresh, create, remove, patch };
}
